import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card'
import { useUnits } from '../../../contexts/UnitsContext'

export function ProgressBar({ startWeight, goalWeight, currentWeight }) {
  const { t } = useTranslation()
  const { weightUnit, formatWeight } = useUnits()
  const totalRange = startWeight - goalWeight
  const lost = currentWeight != null ? startWeight - currentWeight : 0
  const percent = totalRange > 0 ? Math.min(100, Math.max(0, (lost / totalRange) * 100)) : 0

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">
          {t('phoenixTracker.progress.progressBar')}
          <span className="text-sm font-normal text-muted-foreground ms-2">
            {percent.toFixed(1)}% {t('phoenixTracker.progress.completed')}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="relative w-full h-6 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
            {/* Fill anchored to the writing-direction start: left in LTR,
                right in RTL. Both stops come from the selected palette
                so the bar follows the user's primary colour cleanly
                instead of fading to a fixed amber. */}
            <div
              className="absolute inset-y-0 bg-gradient-to-r rtl:bg-gradient-to-l from-app-primary-500 to-app-primary-300 rounded-full transition-all duration-700 ease-out"
              style={{ width: `${percent}%`, insetInlineStart: 0 }}
            />
          </div>
          <div className="flex justify-between text-xs font-mono text-muted-foreground">
            <span>{formatWeight(startWeight)}&nbsp;{weightUnit}</span>
            {currentWeight != null && (
              <span className="text-app-primary-500 font-semibold">{formatWeight(currentWeight)}&nbsp;{weightUnit}</span>
            )}
            <span>{formatWeight(goalWeight)}&nbsp;{weightUnit}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
